exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "legend[data-v-1cf23066] {\n  font-size: 1rem;\n}\n.table th[data-v-1cf23066],\n.table td[data-v-1cf23066] {\n  white-space: nowrap;\n  font-size: small;\n}\n.ccc-card[data-v-1cf23066] {\n  min-height: 90px;\n  filter: grayscale(100%);\n  background-repeat: no-repeat;\n  background-size: contain;\n  opacity: .6;\n  background-position-y: center;\n  background-position-x: center;\n}\n.ccc-card[data-v-1cf23066]:hover {\n  filter: grayscale(0%);\n  opacity: .8;\n}\n.ccc-card.active[data-v-1cf23066] {\n  filter: grayscale(0%);\n  opacity: 1;\n}\n.is-invalid .invalid-feedback[data-v-1cf23066] {\n  display: block;\n}\n", ""]);

// exports
